import { render, staticRenderFns } from "./TariffsScreen.vue?vue&type=template&id=110780ba&scoped=true"
import script from "./TariffsScreen.vue?vue&type=script&lang=js"
export * from "./TariffsScreen.vue?vue&type=script&lang=js"
import style0 from "./TariffsScreen.vue?vue&type=style&index=0&id=110780ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110780ba",
  null
  
)

export default component.exports